import { Application } from 'models/Application/type';
import { ProvisioningProfileRole } from 'models/Application/enum';
import {
  ListResponse,
  ShowResponse,
} from 'repositories/application/responseType';
import { isUser } from 'repositories/device/responseType';
import { getDeviceFamilyType } from 'models/Device/transfer';
import { AvailableApplication } from 'models/Device/type';
import { OwnerType } from 'models/Device/enum';

export const getProvisioningProfileRole = (
  role: number
): ProvisioningProfileRole => {
  switch (role) {
    case 0:
      return ProvisioningProfileRole.adhoc;
    case 1:
      return ProvisioningProfileRole.enterprise;
    case 2:
      return ProvisioningProfileRole.development;
    default:
      return ProvisioningProfileRole.unSupported;
  }
};

export const convertToApplication = (response: ShowResponse): Application => {
  return {
    includeUdid: response.results.binary.is_udid_included,
    isDeveloper: response.results.binary.has_writable,
    iconSrc: response.results.binary.icon,
    ownerName: response.results.binary.user.name,
    bundleIdentifier: response.results.binary.package_name,
    revision: response.results.binary.revision,
    name: response.results.binary.name,
    version: `${response.results.binary.version_name} (${response.results.binary.version_code})`,
    updatedDate: new Date(response.results.binary.updated_at * 1000),
    targetDeviceFamily: getDeviceFamilyType(
      response.results.binary.device_family
    ),
    minimumOsVersion: response.results.binary.target_os_version,
    targetOsVersion: response.results.binary.raw_sdk_version.replace(
      'iphoneos',
      ''
    ),
    provisioningProfile: {
      teamName: response.results.binary.provision_team_name,
      role: getProvisioningProfileRole(response.results.binary.provision_role),
      expirationDate: new Date(
        response.results.binary.provision_expiration_date
      ),
    },
    file: {
      name: response.results.binary.info,
      size: response.results.binary.file_size,
    },
    releaseNote: response.results.binary.message,
  };
};

export const convertToAvailableApplicationList = (
  response: ListResponse
): AvailableApplication[] => {
  return response.results.binaries.map(
    (binary): AvailableApplication => {
      return {
        ownerName: binary.user.name,
        ownerType: isUser(binary.user)
          ? OwnerType.user
          : OwnerType.organization,
        bundleIdentifier: binary.package_name,
        revision: binary.revision,
        iconSrc: binary.icon,
        title: binary.name,
        version: `${binary.version_name} (${binary.version_code})`,
        versionName: binary.version_name,
        releaseNote: binary.message,
        updatedDate: new Date(binary.updated_at * 1000),
        visible: true,
      };
    }
  );
};
